module.exports = __webpack_public_path__ + "img/logo.723ead3d.png";